import { render, staticRenderFns } from "./club.vue?vue&type=template&id=3260808c&scoped=true&"
var script = {}
import style0 from "./club.vue?vue&type=style&index=0&id=3260808c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3260808c",
  null
  
)

export default component.exports